import React from 'react'
import {each, curry} from 'lodash'
import EllipsisText from './EllipsisText'
import NormalizedShortLink from './NormalizedShortLink'
import Select from 'react-select'
import Async from 'react-select/lib/Async'
import Creatable from 'react-select/lib/Creatable'
import SentimentIcon from '../modules/pulse/components/SentimentIcon'
import listingComponents from './listing/listing-components-to-ng'
import BasicSocialImage from './socialimage/BasicSocialImage'
import BasicProviderImage from './providerimage/BasicProviderImage'
import AbbreviatedName from './AbbreviatedName'
import HelpIcon from './HelpIcon'
import {Pagination} from './pagination/Pagination'
import Dropdown from './Dropdown'
import {NotificationList} from '../services/notifications/NotificationList'
import ToastContainer from './toasts/Toasts';
import {SearchToSelect} from '../components'
import {SentimentStoreComparison} from '../modules/pulse/pages/SentimentStoreComparison'
import {InstantAuditsUsage} from '../modules/admin/instantAudits/usage/InstantAuditsUsage'
import {InstantAuditsConfigEditor} from '../modules/admin/instantAudits/config/InstantAuditsConfigEditor'
import ManageLocationsList from '../modules/admin/manageLocations/_core/ManageLocationsList'
import ManageTemplatesList from "../modules/admin/manageTemplates/ManageTemplatesList";
import LocalPagesUploader from "../modules/admin/manageTemplates/LocalPagesUploader";
import {TrackedTopicSetSelector} from '../modules/pulse/components/TrackedTopicSetSelector'
import {PurtyNumber} from './reports/PurtyNumber'
import {MetricDelta} from './reports/MetricDelta'
import {EntityTaskTypeButton} from '../modules/workflow/chromedome/EntityTaskTypeButton'
import {BrandSettings} from '../modules/theme/BrandSettings'
import {GoogleListingVerification} from '../modules/listings/components/GoogleListingVerification'
import {ExportAsImage} from './exports/ExportAsImage'
import UsePageTitle, {PortaledTitleImage, UsePortaledPageTitle} from '../modules/app/layout/UsePageTitle';
import PageTitle from './typography/PageTitle';
import ScoreSummaryPageCommands from "./scores/summary/ScoreSummaryPageCommands";
import SmartResponseButton from "./buttons/SmartResponseButton";
import { UserIdSelector } from '../services/users/UserIdSelector'

/**
 * Registers a list of react components that can be used to in ng templates.
 *
 * @param app The angular app to add the the component to.
 * @param components an array of arrays [name, component] to be registered.
 */
export const addComponents = (app, components) =>
  each(components, ([name, component]) => {
    app.value(name, component)
  })

/**
 * Registers a React component to be used as a directive within angular templates.
 *
 * @param app The angular app to add the the component to as as directive.
 * @param name The name to give to the directive. This follows the traditional ng directive naming convention.
 * @param component The actual component to use. This can be an instance of the component or a string name of the component
 * @param keys The attribute to be passed to the components as props.
 */
export const asDirective = (app, name, component, keys) =>
  app.directive(name, ['reactDirective', (reactDirective) => reactDirective(component, keys)])



/**
 * Bootstraps the react components into angular.
 * @param app The angular app.
 */
const registerComponentsGloballyToNg = app => {
  const addComponentsCurried = curry(addComponents)(app)
  const asDirectiveCurried = curry(asDirective)(app)

  addComponentsCurried([
    ['EllipsisText', EllipsisText],
    ['NormalizedShortLink', NormalizedShortLink],
    ['Select', Select],
    ['Select.Async', Async],
    ['SelectCreatable', Creatable],
    ['SentimentIcon', SentimentIcon],
    ['BasicProviderImage', BasicProviderImage],
    ['BasicSocialImage', BasicSocialImage],
    ['AbbreviatedName', AbbreviatedName],
    ['HelpIcon', HelpIcon],
    ['Pagination', Pagination],
    ['Dropdown', Dropdown],
    ['SearchToSelect', SearchToSelect],
    ['ToastContainer', ToastContainer],
    ['NotificationList',  NotificationList],
    ['UserIdSelector', UserIdSelector],
    ['InstantAuditsUsage',  InstantAuditsUsage],
    ['InstantAuditsConfigEditor',  InstantAuditsConfigEditor],
    ['ManageLocationsList',  ManageLocationsList],
    ['ManageTemplatesList', ManageTemplatesList],
    ['LocalPagesUploader', LocalPagesUploader],
    ['SentimentStoreComparison',  SentimentStoreComparison],
    ['TrackedTopicSetSelector',  TrackedTopicSetSelector],
    ['PurtyNumber', PurtyNumber],
    ['MetricDelta', MetricDelta],
    ['ScoreSummaryPageCommands', ScoreSummaryPageCommands],
    ['EntityTaskTypeButton',EntityTaskTypeButton],
    ['BrandSettings',BrandSettings],
    ['GoogleListingVerification', GoogleListingVerification],
    ['ExportAsImage',ExportAsImage],
    ['UsePageTitle', UsePageTitle],
    ['UsePortaledPageTitle', UsePortaledPageTitle],
    ['PageTitle', PageTitle],
    ['PortaledTitleImage', PortaledTitleImage],
    ['SmartResponseButton', SmartResponseButton]
  ])

  // here we can bootstrap other list of components.
  listingComponents(addComponentsCurried, asDirectiveCurried)
}

export default registerComponentsGloballyToNg
